import { sendToApi } from 'api/client'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'
import { useQuery } from 'react-query'

export enum TikTokPrivacyLevel {
  Public = 'PUBLIC_TO_EVERYONE',
  Mutuals = 'MUTUAL_FOLLOW_FRIENDS',
  Followers = 'FOLLOWER_OF_CREATOR',
  Private = 'SELF_ONLY',
}

type TikTokCreatorInfo = {
  creator_avatar_url: string
  creator_username: string
  creator_nickname: string
  privacy_level_options: TikTokPrivacyLevel[]
  comment_disabled: boolean
  duet_disabled: boolean
  stitch_disabled: boolean
  max_video_post_duration_sec: number
}

type TikTokErrorInfo = {
  code: string
  message: string
  log_id: string
}

export const useTikTokCreatorInfo = ({ externalIntegrationId }: { externalIntegrationId?: number }) => {
  const workspaceId = useCurrentWorkspaceId()
  const response = useQuery(
    ['externalIntegrations', workspaceId, 'tiktok_creator_info', externalIntegrationId],
    async () => {
      const response = await sendToApi<{ data: TikTokCreatorInfo; error: TikTokErrorInfo }>(
        `/w/${workspaceId}/tiktok/integrations/${externalIntegrationId}/creator_info`,
      )

      if (response.type !== SUCCESS_RESPONSE_TYPE) {
        throw new Error(response.data)
      }

      return response.data
    },
    {
      enabled: !!workspaceId && !!externalIntegrationId,
      retry: false,
      retryOnMount: false,
      refetchOnWindowFocus: false,
      cacheTime: 1000 * 60 * 5,
    },
  )

  return response
}
